import '../../components/styles/PharmacovigilanceCommittee.css';
import '../../components/styles/CommitteeTable.css';

const EthicsCommittee = () => {
  const members = [
    { sl: 1, name: 'Dr. Nishanthi. A', designation: 'Professor of Pharmacology, SMVMCH', position: 'Chairperson' },
    { sl: 2, name: 'Dr. Akila S', designation: 'Professor of Pharmacology, CARE, Kelambakkam', position: 'Member' },
    { sl: 3, name: 'Dr. Arulkumaran', designation: 'Professor of Paediatrics, SMVMCH', position: 'Member' },
    { sl: 4, name: 'Dr. Sripal. A', designation: 'Associate Professor of Ophthalmology', position: 'Member' },
    { sl: 5, name: 'Dr. Divya Bharathy. R', designation: 'Assistant Professor of Community Medicine', position: 'Member' },
    { sl: 6, name: 'Dr. S. Rajalakshmi', designation: 'Assistant Professor of OBG', position: 'Member' },
    { sl: 7, name: 'Mr. Sathish', designation: 'Legal Person, Advocate', position: 'Legal Person' },
    { sl: 8, name: 'Mr. R. Rajkumar', designation: 'Project Director, Annai Karunalaya Social Welfare Association, Tindivanam', position: 'Social Scientist' },
    { sl: 9, name: 'Mr. E. Muthukrishnan', designation: 'Ongur', position: 'Lay Person' },
    { sl: 10, name: 'Dr. Saleem. M', designation: 'Professor & HOD of Microbiology', position: 'Secretary' },
    { sl: 11, name: 'Expert from the Specialty Concerned', designation: 'When Necessary', position: 'Member' },
  ];

  const pdfPath = '/assets/document/committee/ethics-committee/Ethics committee.pdf';
  const cdscoPdfPath = '/assets/document/committee/ethics-committee/CDSCO.pdf';

  return (
    <div className="pharma-container">
      <header className="pharma-header">
        <h1>Ethics Committee</h1>
      </header>

      <section className="pharma-description">
        <p>
          The Ethics Committee at Takshashila Medical College is responsible for reviewing and
          approving research protocols involving human subjects, ensuring ethical standards are
          maintained in all clinical and academic activities. It safeguards the rights, safety,
          and well-being of research participants and upholds the principles of medical ethics.
        </p>
      </section>

      <section className="pharma-table-section">
        <div className="ct-table-wrapper">
          <table className="pharma-table ct-table">
            <thead>
              <tr>
                <th>Sl. No.</th>
                <th>Name</th>
                <th>Designation</th>
                <th>Position</th>
              </tr>
            </thead>
            <tbody>
              {members.map((m) => (
                <tr key={m.sl}>
                  <td className="ct-sl" data-label="Sl.">{m.sl}</td>
                  <td data-label="Name">{m.name}</td>
                  <td data-label="Designation">{m.designation}</td>
                  <td data-label="Position">{m.position}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <div className="ct-doc-btn-wrap">
        <a href={`/view-document.html?file=${encodeURIComponent(pdfPath)}`} target="_blank" rel="noopener noreferrer" className="ct-doc-btn">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="12" y1="18" x2="12" y2="12"/>
            <line x1="9" y1="15" x2="15" y2="15"/>
          </svg>
          View Official Document
        </a>
        <a href={`/view-document.html?file=${encodeURIComponent(cdscoPdfPath)}`} target="_blank" rel="noopener noreferrer" className="ct-doc-btn">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="12" y1="18" x2="12" y2="12"/>
            <line x1="9" y1="15" x2="15" y2="15"/>
          </svg>
          View CDSCO Document
        </a>
      </div>
    </div>
  );
};

export default EthicsCommittee;
